// Container.tsx
import elements from './items';
import { FC } from 'react';
import { ItemProps } from '@/components/Form/types';
import HelpTooltip from '@/components/UiElements/HelpTooltip';

const noLabel = ['Checkbox', 'Hidden'];
const noHelpTooltip = ['Preview', 'Hidden', 'Divider'];

const Container: FC<ItemProps> = (item) => {
    let Component = item.formItem.theme || elements[item.type];

    // Construct a FormItemsProps object from ItemProps


    const content = (
        <div
            className={
                `FormContainer flex flex-col gap-sm justify-start min-h-[44px] ${item.classNames?.container || ""} ` +
                `${item.type === 'Hidden' ? 'hidden' : ''}`
            }
            id = {`form-${item.formId}-${item.name}`}
        >
            {(!noLabel.includes(item.type) && item.formItem.label) &&
                <div className={`FormContainerLabel select-none flex flex-col items-start justify-between gap-xs text-gray-900 text-text-md ${item.classNames?.label || ""}`}>
                    {item.label}
					{(!noLabel.includes(item.type) && item.formItem.hint) &&
						<div className={`FormContainerLabelHint select-none flex items-center pb-sm justify-between gap-md text-gray-400 text-text-md ${item.classNames?.hint || ""}`}>
							{item.formItem.hint}
						</div>
					}
                </div>
            }


            <div className={`FormContainerContent flex flex-col gap-xs ${item.classNames?.content || ""}`}>
                {Component && <Component {...item} formData={item.formData} />}
            </div>
        </div>
    );

	if (!item.formItem.help || noHelpTooltip.includes(item.type)) return content;

	return (
		<HelpTooltip
			help={item.formItem.help}
			imageUrl={item.formItem.helpImageUrl}
			imageAlt={item.formItem.helpImageAlt}
		>
			{content}
		</HelpTooltip>
	);
};

export default Container;
